<app-no-contract></app-no-contract>


<!-- if user have contract-->
<p-panel header="{{'pages_titles.consumption-ceiling' | translate}}" *ngIf="isContractActive">
    <app-loader *ngIf="loadConsumptionLimit"></app-loader>
    <form *ngIf="!loadConsumptionLimit">
        <div class="row  ml-3 mr-3">
            <!--Plafond-->
            <div class=" col-md-6 col-sm-12  mb-2">
                <label class="col-form-label" for="CeilingAmount"> {{'Ceiling-amount' | translate}} <span
                        class="text-danger">*</span></label>
                <p-inputNumber [style]="{'width': '100%'}" class="w-100" [disabled]="Load" name="CeilingAmount" required
                    [(ngModel)]="consumptionCeiling.amount" [showButtons]="true" mode="currency" currency="EUR">
                </p-inputNumber>
            </div>

            <!--Expire date-->
            <div class=" col-md-6  col-sm-12  mb-2">
                <label class="col-form-label" for="date"> {{'date-reset' | translate}} <span
                        class="text-danger">*</span></label>
                <p-dropdown appendTo="body" [disabled]="Load" [options]="dateReset" optionLabel="name" optionValue="code" name="reset"
                    [(ngModel)]="consumptionCeiling.reset" placeholder="{{'monthly' | translate}}"></p-dropdown>
            </div>

            <!--charge-refuse-if-exceeded-->
            <div class=" col-12  mb-2">
                <label class="col-form-label d-block"> {{'charge-refuse-if-exceeded' | translate}} <span
                        class="text-danger">*</span></label>
                <div class="p-field-radiobutton d-inline-block">
                    <p-radioButton [disabled]="Load" name="yes" value="true" [(ngModel)]="consumptionCeiling.charge"
                        inputId="yes"></p-radioButton>
                    <label for="yes" class="mb-0 ml-2"> {{'yes' | translate}}</label>
                </div>
                <div class="p-field-radiobutton mt-2 ml-3 d-inline-block">
                    <p-radioButton [disabled]="Load" name="no" value="false" [(ngModel)]="consumptionCeiling.charge"
                        inputId="no"></p-radioButton>
                    <label for="no" class="mb-0 ml-2">{{'no' | translate}}</label>
                </div>
            </div>

            <div class="ml-auto mr-auto mt-3">
                <button pButton [disabled]="Load" icon="pi pi-check" iconPos="left" (click)="createPlafond()"
                 type="button" label="{{'actions.save' | translate}}" ></button>
            </div>
        </div>
    </form>
</p-panel>